/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ScholarshiptypeClassStudents200,
  GetApiV1ScholarshiptypeClassStudents401,
  GetApiV1ScholarshiptypeClassStudents500,
  GetApiV1ScholarshiptypeClassStudentsQueryParams,
  GetApiV1ScholarshiptypeClassStudentsQueryResponse,
} from "../../types/scholarshipTypeRegistroController/GetApiV1ScholarshiptypeClassStudents.ts";
import { classStudentTagViewModelSchema } from "../classStudentTagViewModelSchema.ts";

export const getApiV1ScholarshiptypeClassStudentsQueryParamsSchema = z
  .object({
    filter: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1ScholarshiptypeClassStudentsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ScholarshiptypeClassStudents200Schema = z.array(
  z.lazy(() => classStudentTagViewModelSchema),
) as unknown as ToZod<GetApiV1ScholarshiptypeClassStudents200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ScholarshiptypeClassStudents401Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshiptypeClassStudents401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ScholarshiptypeClassStudents500Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshiptypeClassStudents500>;

export const getApiV1ScholarshiptypeClassStudentsQueryResponseSchema = z.lazy(
  () => getApiV1ScholarshiptypeClassStudents200Schema,
) as unknown as ToZod<GetApiV1ScholarshiptypeClassStudentsQueryResponse>;
